import { Reward, RewardName } from '../../graphql/rewards';

export const getCvRewardPoints = (rewardList?: Reward[] | null): number | null =>
  rewardList?.find((r) => r.name === RewardName.controlVisit)?.points ?? null;
